// =============================================
// SCROLL TO TOP — Show/hide button and scroll functionality
// =============================================

(function () {
  const scrollToTopBtn = document.getElementById('scroll-to-top');

  if (!scrollToTopBtn) return;

  // Show/hide button based on scroll position
  function toggleScrollToTop() {
    const scrolled = window.pageYOffset || document.documentElement.scrollTop;
    const threshold = 300; // Show button after scrolling 300px

    if (scrolled > threshold) {
      scrollToTopBtn.classList.add('visible');
    } else {
      scrollToTopBtn.classList.remove('visible');
    }
  }

  // Scroll to top function
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  // Event listeners
  window.addEventListener('scroll', toggleScrollToTop, { passive: true });
  scrollToTopBtn.addEventListener('click', scrollToTop);

  // Initial check in case page is loaded scrolled
  toggleScrollToTop();
})();